/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：751
 */

module.exports = {
  saveTipsWrapper: "styles_saveTipsWrapper__1fMtC",
  saveTipsMask: "styles_saveTipsMask__3Mffu",
  saveTipsContent: "styles_saveTipsContent__279zE",
  slideInDown: "styles_slideInDown__2Dzfv",
  name: "styles_name__kF7Z3",
  description: "styles_description__3X0Kc",
  actions: "styles_actions__2fhi8"
}
